(function() {
    const faqQuestions = document.querySelectorAll('.accordion__button-text');
    const faqAnswers = document.querySelectorAll('.accordion__body-inner p');
    const faqData = [];

    faqQuestions.forEach((question , index) => {
        const questionText = question.textContent.trim();
        const answerText = faqAnswers[index] ? faqAnswers[index].textContent.trim() : '';

        faqData.push({
            "@type": "Question",
            "name": questionText,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": answerText
            }
        });
    })

    console.log(faqData);

    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqData
    });

    document.head.appendChild(schemaScript);

})();
